export class Tenant {
  tenantName!: string;
  companyName!: string;
  apiUrl!: string;
  cdnUrl!: string;
  logoUrl!: string;
  /**
   * Square company icon (at least 96 px) for places the wide logo does not fit, such as the
   * collapsed sidebar. Absent (the master leaves out null) when the tenant has none.
   */
  iconUrl?: string | null;
  clientId!: string;
  /** Lifecycle fields from the master (PR #149). Missing on older masters, which means `Active`. */
  lifecycleState?: string | null;
  trialEndsAt?: string | null;
  listeningEndsAt?: string | null;
  deletionAt?: string | null;
  activationScheduled?: boolean | null;
}
